export const FILE_UPLOAD_PURPOSE = {
  PAYMENT_COPY: 'payment-copy',
} as const

export type FileUploadPurpose = (typeof FILE_UPLOAD_PURPOSE)[keyof typeof FILE_UPLOAD_PURPOSE]
